<template>
  <div class="linkContainer" v-if="!hamburguerMenu">
    <el-menu
      router
      :default-active="$route.path"
      class="navBar"
      mode="vertical"
      :collapse="this.collapsed"
    >
      <el-menu-item index="/pedidos" v-if="tienePermiso(targets.Menu_Pedido)">
        <i class="el-icon-shopping-cart-2"></i>
        <span slot="title">{{ $t('NAVBAR_pedidos') }}</span>
      </el-menu-item>

      <el-menu-item index="/pedidosSubagentes" v-if="tienePermiso(targets.Menu_PedidoSubagentes)">
        <i class="el-icon-shopping-cart-1"></i>
        <span slot="title">{{ $t('NAVBAR_pedidosSubagentes') }}</span>
      </el-menu-item>

      <el-menu-item index="/pedidosDistribuidores" v-if="tienePermiso(targets.Menu_PedidoADistribuidores)">
        <i class="el-icon-shopping-cart-full"></i>
        <span slot="title">{{ $t('NAVBAR_pedidosDistribuidores') }}</span>
      </el-menu-item>

      <el-menu-item index="/presupuestos" v-if="tienePermiso(targets.Menu_Presupuesto)">
        <i class="el-icon-tickets"></i>
        <span slot="title">{{ $t('NAVBAR_presupuestos') }}</span>
      </el-menu-item>

      <el-menu-item index="/firmarRemitos" v-if="tienePermiso(targets.Menu_FirmarRemito)">
        <i class="el-icon-edit-outline"></i>
        <span slot="title">{{ $t('NAVBAR_firmarRemitos') }}</span>
      </el-menu-item>
      
      <div class="divider" v-if="tienePermiso(targets.Menu_RegistroInstalacion) || tienePermiso(targets.Menu_GarantiaProximaVencer) || tienePermiso(targets.Menu_SolicitudServicio) || tienePermiso(targets.Menu_AsociarRemito)"></div>

      <el-menu-item index="/garantias" v-if="tienePermiso(targets.Menu_RegistroInstalacion)">
        <i class="el-icon-document-checked"></i>
        <span slot="title">{{ $t('NAVBAR_reg_instalacion') }}</span>
      </el-menu-item>

      <el-menu-item index="/garantias/expiracion" v-if="tienePermiso(targets.Menu_GarantiaProximaVencer)">
        <i class="el-icon-time"></i>
        <span slot="title">{{ $t('NAVBAR_expire_warranty') }}</span>
      </el-menu-item>

      <el-menu-item index="/solicitudes" v-if="tienePermiso(targets.Menu_SolicitudServicio)">
        <i class="el-icon-notebook-2"></i>
        <span slot="title">{{ $t('NAVBAR_solicitudes') }}</span>
      </el-menu-item>

      <el-menu-item index="/remitos" v-if="tienePermiso(targets.Menu_AsociarRemito)">
        <i class="el-icon-document-checked"></i>
        <span slot="title">{{ $t('NAVBAR_remitos') }}</span>
      </el-menu-item>

      <div class="divider" v-if="tienePermiso(targets.Menu_Pendientes) || tienePermiso(targets.Menu_ResumenDeCuenta) || tienePermiso(targets.Menu_Clientes)"></div>

      <el-menu-item index="/pendientes" v-if="tienePermiso(targets.Menu_Pendientes) || tienePermiso(targets.Menu_Clientes)">
        <i class="el-icon-data-analysis"></i>
        <span slot="title">{{ $t('NAVBAR_pendientes') }}</span>
      </el-menu-item>

      <el-menu-item index="/resumenDeCuenta" v-if="tienePermiso(targets.Menu_ResumenDeCuenta) || tienePermiso(targets.Menu_Clientes)">
        <i class="el-icon-document"></i>
        <span slot="title">{{ $t('NAVBAR_resumenDeCuenta') }}</span>
      </el-menu-item>

      <!-- <el-menu-item index="/clientes" v-if="tienePermiso(targets.Menu_Clientes)">
        <i class="el-icon-user"></i>
        <span slot="title">{{ $t('NAVBAR_clientes') }}</span>
      </el-menu-item> -->

      <div class="divider" v-if="tienePermiso(targets.Menu_Gestion_Noticia) || tienePermiso(targets.Menu_Foro) || tienePermiso(targets.Menu_Gestion_Archivo)"></div>

      <el-menu-item index="/gestionNoticias" v-if="tienePermiso(targets.Menu_Gestion_Noticia)">
        <i class="el-icon-document-copy"></i>
        <span slot="title">{{ $t('NAVBAR_gestionNoticias') }}</span>
      </el-menu-item>

      <el-menu-item index="/foro" v-if="tienePermiso(targets.Menu_Foro)">
        <i class="el-icon-chat-dot-square"></i>
        <span slot="title">{{ $t('NAVBAR_foro') }}</span>
      </el-menu-item>

      <el-menu-item index="/archivos" v-if="tienePermiso(targets.Menu_Gestion_Archivo)">
        <i class="el-icon-receiving"></i>
        <span slot="title">{{ $t('NAVBAR_archivos') }}</span>
      </el-menu-item>

      <div class="divider" v-if="tienePermiso(targets.Menu_Contacto)"></div>

      <el-menu-item index="/contacto" v-if="tienePermiso(targets.Menu_Contacto)">
        <i class="el-icon-message"></i>
        <span slot="title">{{ $t('NAVBAR_contacto') }}</span>
      </el-menu-item>


    </el-menu>
  </div>

  <div v-else class="hamburguerMenu" @click="toggleHamburguerMenu">
    <div>
      <i class="el-icon-s-unfold"></i>
    </div>

    <el-menu
      v-if="hamburguerActive"
      router
      :default-active="$route.path"
      class="hamburguerList"
      mode="vertical"
    >
      <el-menu-item index="/pedidos" v-if="tienePermiso(targets.Menu_Pedido)">
        <i class="el-icon-shopping-cart-2"></i>
        <span slot="title">{{ $t('NAVBAR_pedidos') }}</span>
      </el-menu-item>

      <el-menu-item index="/pedidosSubagentes" v-if="tienePermiso(targets.Menu_PedidoSubagentes)">
        <i class="el-icon-shopping-cart-1"></i>
        <span slot="title">{{ $t('NAVBAR_pedidosSubagentes') }}</span>
      </el-menu-item>

      <el-menu-item index="/pedidosDistribuidores" v-if="tienePermiso(targets.Menu_PedidoADistribuidores)">
        <i class="el-icon-shopping-cart-full"></i>
        <span slot="title">{{ $t('NAVBAR_pedidosDistribuidores') }}</span>
      </el-menu-item>

      <el-menu-item index="/presupuestos" v-if="tienePermiso(targets.Menu_Presupuesto)">
        <i class="el-icon-tickets"></i>
        <span slot="title">{{ $t('NAVBAR_presupuestos') }}</span>
      </el-menu-item>

      <el-menu-item index="/firmarRemitos" v-if="tienePermiso(targets.Menu_FirmarRemito)">
        <i class="el-icon-edit-outline"></i>
        <span slot="title">{{ $t('NAVBAR_firmarRemitos') }}</span>
      </el-menu-item>

      <div class="divider" v-if="tienePermiso(targets.Menu_RegistroInstalacion) || tienePermiso(targets.Menu_GarantiaProximaVencer) || tienePermiso(targets.Menu_SolicitudServicio) || tienePermiso(targets.Menu_AsociarRemito)"></div>

      <el-menu-item index="/garantias" v-if="tienePermiso(targets.Menu_RegistroInstalacion)">
        <i class="el-icon-document-checked"></i>
        <span slot="title">{{ $t('NAVBAR_reg_instalacion') }}</span>
      </el-menu-item>

      <el-menu-item index="/garantias/expiracion" v-if="tienePermiso(targets.Menu_GarantiaProximaVencer)">
        <i class="el-icon-time"></i>
        <span slot="title">{{ $t('NAVBAR_expire_warranty') }}</span>
      </el-menu-item>

      <el-menu-item index="/solicitudes" v-if="tienePermiso(targets.Menu_SolicitudServicio)">
        <i class="el-icon-notebook-2"></i>
        <span slot="title">{{ $t('NAVBAR_solicitudes') }}</span>
      </el-menu-item>

      <el-menu-item index="/remitos" v-if="tienePermiso(targets.Menu_AsociarRemito)">
        <i class="el-icon-document-checked"></i>
        <span slot="title">{{ $t('NAVBAR_remitos') }}</span>
      </el-menu-item>

      <div class="divider" v-if="tienePermiso(targets.Menu_Pendientes) || tienePermiso(targets.Menu_ResumenDeCuenta) || tienePermiso(targets.Menu_Clientes)"></div>

      <el-menu-item index="/pendientes" v-if="tienePermiso(targets.Menu_Pendientes) || tienePermiso(targets.Menu_Clientes)">
        <i class="el-icon-data-analysis"></i>
        <span slot="title">{{ $t('NAVBAR_pendientes') }}</span>
      </el-menu-item>

      <el-menu-item index="/resumenDeCuenta" v-if="tienePermiso(targets.Menu_ResumenDeCuenta) || tienePermiso(targets.Menu_Clientes)">
        <i class="el-icon-document"></i>
        <span slot="title">{{ $t('NAVBAR_resumenDeCuenta') }}</span>
      </el-menu-item>

      <!-- <el-menu-item index="/clientes" v-if="tienePermiso(targets.Menu_Clientes)">
        <i class="el-icon-user"></i>
        <span slot="title">{{ $t('NAVBAR_clientes') }}</span>
      </el-menu-item> -->

      <div class="divider" v-if="tienePermiso(targets.Menu_Gestion_Noticia) || tienePermiso(targets.Menu_Foro) || tienePermiso(targets.Menu_Gestion_Archivo)"></div>

      <el-menu-item index="/gestionNoticias" v-if="tienePermiso(targets.Menu_Gestion_Noticia)">
        <i class="el-icon-document-copy"></i>
        <span slot="title">{{ $t('NAVBAR_gestionNoticias') }}</span>
      </el-menu-item>

      <el-menu-item index="/foro" v-if="tienePermiso(targets.Menu_Foro)">
        <i class="el-icon-chat-dot-square"></i>
        <span slot="title">{{ $t('NAVBAR_foro') }}</span>
      </el-menu-item>

      <el-menu-item index="/archivos" v-if="tienePermiso(targets.Menu_Gestion_Archivo)">
        <i class="el-icon-receiving"></i>
        <span slot="title">{{ $t('NAVBAR_archivos') }}</span>
      </el-menu-item>

      <div class="divider" v-if="tienePermiso(targets.Menu_Contacto)"></div>

      <el-menu-item index="/contacto" v-if="tienePermiso(targets.Menu_Contacto)">
        <i class="el-icon-message"></i>
        <span slot="title">{{ $t('NAVBAR_contacto') }}</span>
      </el-menu-item>

    </el-menu>
  </div>
</template>

<script>
  import { targets } from '../../security/target'
  import { tienePermiso } from '../../security/autorizador'

  export default {
    name: "LeftNavBar",
    data() {
      return {
        targets: targets,

        collapsed: false,
        hamburguerMenu: true,
        hamburguerActive: false
      };
    },
    methods: {
      tienePermiso: tienePermiso,

      onResize() {
        if (window.innerWidth < 801 && window.innerWidth > 600) {
          this.collapsed = true;
          this.hamburguerMenu = false;
        } else if (window.innerWidth < 600) {
          this.hamburguerMenu = true;
        } else {
          this.collapsed = false;
          this.hamburguerMenu = false;
        }
      },
      toggleHamburguerMenu() {
        this.hamburguerActive = !this.hamburguerActive;
      }
    },
    mounted() {
      // Register an event listener when the Vue component is ready
      window.addEventListener("resize", this.onResize);
      this.onResize();
    },
    beforeDestroy() {
      // Unregister the event listener before destroying this Vue instance
      window.removeEventListener("resize", this.onResize);
    }
  }
</script>

<style scoped>
.linkContainer {
  margin-top: 20px;
}

.navBar:not(.el-menu--collapse) {
  width: 273px;
}
.hamburguerMenu {
  float: left;
  padding-top: 10px;
  padding-right: 10px;
  text-align: left;
  color: white;
}
.hamburguerList {
  top: 40px;
  left: 0px;
  position: fixed;
  width: 100vw;
  padding: 5px 0;
}
.divider {
  border-top: 1px solid #e5e5e5;
  margin: 16px 0;
}
</style>
